// @flow

const billingHomeStyles = {
  root: (theme) => ({
    minHeight: '100vh',
    display: 'flex'
  })
};

export default billingHomeStyles;
